export default {"src":"/_next/static/media/apple-store.893270f1.svg","height":40,"width":137,"blurWidth":0,"blurHeight":0};